import React, { useCallback } from 'react';
import { LsDataContainer } from '../../components/LsContainer';
import { apiGroupTagsRead } from '../../api/group_tags';

export const GroupTagsContext = React.createContext(null);
export const GroupTagsContainer = ({ uids, children, ...props }) => {
	const extendContext = useCallback(async ({ data, functions }) => {
		if (_.isNil(data) && !_.isEmpty(uids)) {
			const { groupTags } = await apiGroupTagsRead(uids);
			data = groupTags;
		}
		if (!_.isNil(functions)) {
			functions.add_group_tag = async (group_tag) => {
				const new_data = _.assign({}, _.cloneDeep(data), {
					[group_tag.uid]: group_tag,
				});
				functions.setData(new_data);
			};
			functions.add_group_tag_by_uid = async (uid) => {
				const new_data = _.cloneDeep(data);
				const { data: new_group_tags } = await apiGroupTagsRead({
					uids: [uid],
				});
				// const new_group_tag = await load_group_tags([uid]);
				functions.setData(_.assign({}, new_data, new_group_tags));
			};
			functions.remove_group_tag_by_uid = async (uid) => {
				const new_data = _.cloneDeep(data);
				functions.setData(_.omit(new_data, [uid]));
			};
		}
		return { data, functions };
	}, []);

	return (
		<LsDataContainer
			id={{ uids }}
			context={GroupTagsContext}
			loader={async () => {
				const { data } = await apiGroupTagsRead({ uids });
				return data;
			}}
			extendContext={extendContext}
			renderAlways
			{...props}
		>
			{children}
		</LsDataContainer>
	);
};

GroupTagsContainer.propTypes = LsDataContainer.propTypes;
GroupTagsContainer.propTypes = {
	...LsDataContainer.propTypes,
};
